import { jsx as _jsx } from "react/jsx-runtime";

function SvgDownload() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.383 15.924a.996.996 0 01-.38.076h-.006a.997.997 0 01-.697-.286l-.008-.008-5-4.999a1 1 0 011.415-1.414L11 12.586V3a1 1 0 112 0v9.586l3.293-3.293a1 1 0 111.414 1.414l-5 5m-.002.002a.997.997 0 01-.322.215zM3 14a1 1 0 011 1v4a1 1 0 001 1h14a1 1 0 001-1v-4a1 1 0 112 0v4a3 3 0 01-3 3H5a3 3 0 01-3-3v-4a1 1 0 011-1z"
    }, void 0)
  }), void 0);
}

export default SvgDownload;